import React from "react";
import { connect } from "react-redux";
import { Button, Table } from "react-bootstrap";
import {
  addPayoutInfoLine,
  deletePayoutInfoLine,
  editPayoutInfoLine
} from "../redux/actions";

function PayoutInfoTable({
  payoutInfo,
  addPayoutInfoLine,
  deletePayoutInfoLine,
  editPayoutInfoLine
}) {
  {
    /**
     * TODO: Button to show either + or - (done)
     * if -, use the index to remove the record (done)
     * work on change for each input (done)
     * check the value is passed to the backend (done)
     * split it as new component
     * work on css
     *
     *
     */
  }
  return (
    <>
      <h3>Payout Table Information</h3>
      <Table variant="sm">
        <thead>
          <tr>
            <th>Supplier/Financier</th>
            <th>Contract Identifier</th>
            <th>Payout Funds (including GST)</th>
            <th />
          </tr>
          {payoutInfo.map((payoutItem, rowIndex) => (
            <tr key={rowIndex}>
              <td>
                <input
                  onChange={e =>
                    editPayoutInfoLine(
                      payoutInfo,
                      rowIndex,
                      "SupplierOrFinancer",
                      e.target.value
                    )
                  }
                  className="form-control"
                  type="text"
                  value={payoutItem.SupplierOrFinancer}
                ></input>
              </td>
              <td>
                <input
                  onChange={e =>
                    editPayoutInfoLine(
                      payoutInfo,
                      rowIndex,
                      "ContractIdentifier",
                      e.target.value
                    )
                  }
                  className="form-control"
                  type="text"
                  value={payoutItem.ContractIdentifier}
                ></input>
              </td>
              <td>
                <input
                  onChange={e =>
                    editPayoutInfoLine(
                      payoutInfo,
                      rowIndex,
                      "PayoutFunds",
                      e.target.value
                    )
                  }
                  className="form-control"
                  type="number"
                  value={payoutItem.PayoutFunds}
                ></input>
              </td>
              <td style={{ width: "50px" }}>
                {rowIndex ? (
                  <Button
                    variant="secondary"
                    block
                    onClick={() => {
                      deletePayoutInfoLine(payoutInfo, rowIndex);
                    }}
                  >
                    -
                  </Button>
                ) : (
                  <Button
                    block
                    onClick={() => {
                      addPayoutInfoLine(payoutInfo);
                    }}
                  >
                    +
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </thead>
      </Table>
    </>
  );
}

export default connect(
  state => ({
    payoutInfo: state.quote.finance.payoutInfo
  }),
  {
    addPayoutInfoLine,
    deletePayoutInfoLine,
    editPayoutInfoLine
  }
)(PayoutInfoTable);
